var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunicationCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Communication_Center1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication_Center1",
    "data-name": "Communication Center1",
    clipPath: "url(#clip-Communication_Center1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(478.375 -320.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21187",
    "data-name": "Path 21187",
    d: "M291.812,264.236a.312.312,0,0,1,.311-.312h.928a1.054,1.054,0,0,0,1.054-1.054v-4.012a1.054,1.054,0,0,0-1.054-1.054h-6.629a1.054,1.054,0,0,0-1.054,1.054v4.012a1.054,1.054,0,0,0,1.054,1.054h2.79a.313.313,0,0,1,.282.177l0,0a4.955,4.955,0,0,0,1.331,1.582h0a.638.638,0,0,0,1.033-.557c-.021-.265-.043-.576-.049-.895Zm.578-2.689h-4.462a.252.252,0,0,0,0,.5h4.462a.252.252,0,0,0,0-.5Zm0-1.872h-5.305a.252.252,0,0,0,0,.5h5.305a.252.252,0,0,0,0-.5Z",
    transform: "translate(-758.311 68.288)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21188",
    "data-name": "Path 21188",
    d: "M209.893,189.125a1.55,1.55,0,0,1-.338-.969v-3.981h-1.835a.252.252,0,1,1,0-.5h1.908a1.558,1.558,0,0,1,1.484-1.084h6.166v-2.709a1.355,1.355,0,0,0-1.355-1.355H206.81a1.355,1.355,0,0,0-1.355,1.355v5.515a1.355,1.355,0,0,0,1.355,1.355l1.275,0h0a.522.522,0,0,1,.522.522c-.008.443-.039.872-.068,1.243a.783.783,0,0,0,1.267.68h0l.085-.069Zm-2.174-7.524h7.293a.252.252,0,0,0,0-.5h-7.293a.252.252,0,0,0,0,.5Z",
    transform: "translate(-683 143)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationCenter);
export default __webpack_public_path__ + "static/media/CommunicationCenter.276ede295b9d3c2c875bea7302c3f0ce.svg";
export { ForwardRef as ReactComponent };